import React from 'react';
import * as sharingLinkActions from '../actions';
import { App, Button } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import { getSelectedIds, getLinksById } from '../selectors';
import { useMemo } from 'react';

export const ActivateButton = () => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getSelectedIds);
  const linksById = useSelector(getLinksById);
  const { modal } = App.useApp();
  const disabled = useMemo(
    () => !selectedIds.length || selectedIds.some((id) => linksById[id]?.is_active),
    [selectedIds, linksById],
  );

  return (
    <Button
      title="Activate selected"
      className="al-btn-blue-icon"
      disabled={disabled}
      onClick={() => {
        modal.confirm({
          content: `Links to be activated: ${selectedIds.length}`,
          onOk: (close) => {
            dispatch(sharingLinkActions.activateClicked());
            close();
          },
          icon: null,
        });
      }}
    >
      Activate
    </Button>
  );
};
